import MessageHistory from './MessageHistory';

export default MessageHistory;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/index.js